import React, { useState, useEffect, memo } from "react";
import styled from "@emotion/styled";
import { Outlet } from "react-router-dom";
import { SidebarData } from "./SidebarData";
import SubMenu from "./SubMenu";
import "../../assets/DigitalMarketing/Css/Style.css";
import logo from "../../assets/DigitalMarketing/image/Asset 3_whitebg.png";
import Header from "../../Component/DigitalMarketing/Header";
import { Button } from "@mui/material";
import { Col, Container, Row } from "react-bootstrap";
import * as MdIcons from "react-icons/md";
import * as RxIcons from "react-icons/rx";
import { useSelector } from "react-redux/es/hooks/useSelector";
import { logOut } from "../../store/reducers/auth";
import { useDispatch } from "react-redux";
import PermissionCheck from "../../Component/PermissionCheck";
import useDeleteBox from "../../hooks/digitalMarketing/useDeleteBox";
import Store from "../../store/Store";
import AlertNewDialog from "../../Component/DigitalMarketing/logoutConfirmation";

interface SidebarProps {
  sidebar?: boolean;
  shotbar?: boolean;
}
const SidebarNav = styled.nav<SidebarProps>`
  width: ${({ shotbar }: any) =>
    shotbar
      ? ({ sidebar }: any) => (sidebar ? "251px" : "0px")
      : ({ sidebar }: any) => (sidebar ? "251px" : "0px")};
  height: 99%;
  justify-content: center;
  position: fixed;
  display: flex;
  transition: 350ms;
  z-index: 999;
  overflow-y: auto;
  border-right: 1px solid #e8eaec;
`;

const SidebarWrap = styled.div`
  overflow-y: auto;
  overflow-x: hidden;
`;
function Sidebar() {
  const [sidebar, setSidebar] = useState(true);
  const excludedHospitalCodes = [
    "Livf_Fertility_229",
    "MR_hospital_673",
    "A4_hospital_959",
  ]; // List of hospital codes

  const [shotbar, setshotbar] = useState(true);
  const showSidebar = () => setSidebar(!sidebar);
  const Data = useSelector((state: any) => state.header);
  const account = useSelector((state: any) => state.auth);
const {roleName} = account
  const { open, message, openDelete, deleteId } = useDeleteBox();
  const dispatch = useDispatch<any>();
  let autoResize = () => {
    if (window.innerWidth < 991) {
      setSidebar(false);
      setshotbar(false);
    } else {
      setSidebar(true);
      setshotbar(true);
    }
  };
  useEffect(() => {
    window.addEventListener("resize", autoResize);
    autoResize();
  }, []);
  const LogoutHandle = async (bool) => {
    if (bool) {
      dispatch(logOut());
    }
    openDelete("Are you sure you want to Logout?", false, null);
  };
  return (
    <React.Fragment>
      <>
        <div className="layout-wrapper layout-content-navbar">
          <>
            <AlertNewDialog
              title="Logout Confirmation"
              open={open}
              message={message}
              deleteBranches={LogoutHandle}
            />
          </>
          {Data.overlay && (
            <div className="loader-overlay">
              <div className="loader-ove"></div>
            </div>
          )}
          <div className="layout-container">
            <SidebarNav
              className="layout-menu menu-vertical bg-menu-theme"
              sidebar={sidebar}
              shotbar={shotbar}
            >
              {shotbar ? (
                <img
                  style={{ position: "fixed", margin: "-12px 0" }}
                  src={logo}
                  width="168"
                  alt="logo"
                />
              ) : (
                ""
              )}
              <SidebarWrap className="sidebar-wrap">
                <ul className="menu-inner py-1">
                  {SidebarData?.filter((item) =>
                    item?.roles?.includes(roleName)
                  ).map((item, index) => (
                    <li className="menu-item" key={index}>
                      <SubMenu item={item} sidebar={sidebar} />
                    </li>
                  ))}
                  {/* <li className="foot" style={{ padding: "15px" }}>
                    <SidebarNavLink>
                      <div
                        className="cursur"
                        onClick={() => dispatch(logOut())}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="22"
                          viewBox="0 0 22 26"
                          fill="none"
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M10.8234 21.1309V22.3576C10.8234 23.3414 10.3331 24.1907 9.48108 24.6825C9.07117 24.9191 8.61366 25.0512 8.13932 25.0514C7.66456 25.0516 7.20719 24.9194 6.79699 24.6825L1.34228 21.5332C0.490201 21.0413 0 20.1922 0 19.2083V3.12011C0 1.63975 1.20425 0.435547 2.68457 0.435547H14.6978C16.1782 0.435547 17.3826 1.63965 17.3826 3.12011V6.51147C17.3826 6.99797 16.9876 7.39297 16.5011 7.39297C16.0144 7.39297 15.6197 6.99801 15.6197 6.51147V3.12011C15.6197 2.61179 15.2061 2.19817 14.6978 2.19817H4.17108L9.48108 5.26443C10.3328 5.75626 10.8234 6.60532 10.8234 7.58884V19.368H14.6978C15.2061 19.368 15.6197 18.9547 15.6197 18.4463V15.4734C15.6197 14.9865 16.0142 14.5918 16.5011 14.5918C16.9877 14.5918 17.3826 14.9866 17.3826 15.4734V18.4463C17.3826 19.9267 16.1782 21.1309 14.6978 21.1309H10.8234ZM18.991 11.6645L18.0202 12.6352C17.676 12.9794 17.6761 13.5374 18.0202 13.8816C18.1859 14.0474 18.4092 14.1395 18.6434 14.1395C18.878 14.1395 19.101 14.0477 19.2669 13.8816L21.7419 11.4062C22.086 11.0621 22.0861 10.5044 21.7419 10.1602L19.2669 7.68519C18.9227 7.34095 18.3646 7.3411 18.0203 7.68514C17.6762 8.02899 17.6763 8.58722 18.0203 8.93117L18.991 9.90167H12.488C12.001 9.90167 11.6066 10.2963 11.6066 10.7832C11.6066 11.2702 12.001 11.6645 12.488 11.6645H18.991V11.6645Z"
                            fill="#AA0E17"
                          />
                        </svg>
                        <SidebarLabel>Logout</SidebarLabel>
                      </div>
                    </SidebarNavLink>
                  </li> */}
                </ul>
              </SidebarWrap>
            </SidebarNav>
            <div
              className={
                sidebar
                  ? shotbar
                    ? "layout-page"
                    : "layout-pagii"
                  : shotbar
                  ? "layout-pag"
                  : "layout-page"
              }
            >
              <Container fluid>
                <Row
                  className={shotbar ? "Header-row" : "Header-row fixed-top"}
                >
                  <Col>
                    <ul>
                      {shotbar ? (
                        <Header
                          check={Data?.status}
                          title1={Data?.title?.first}
                          title2={Data?.title?.second}
                          title3={Data?.title?.third}
                        />
                      ) : (
                        <li className="ham-handle">
                          <span>
                            <RxIcons.RxHamburgerMenu
                              className="ham-icon cursor"
                              onClick={showSidebar}
                            />
                          </span>
                          <Header
                            check={Data?.status}
                            title1={Data?.title?.first}
                            title2={Data?.title?.second}
                            title3={Data?.title?.third}
                          />
                        </li>
                      )}
                      <li>
                        <div style={{ float: "right" }}>
                          {/* <i className="icons cursor">
                            <IoIcons.IoMdNotificationsOutline />
                          </i> */}
                          {/* <i className="icons cursor">
                            <RxIcons.RxDashboard />
                          </i> */}
                          {/* <div
                            className="cursur"
                            onClick={() => dispatch(logOut())}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="18"
                              height="22"
                              viewBox="0 0 22 26"
                              fill="none"
                            >
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M10.8234 21.1309V22.3576C10.8234 23.3414 10.3331 24.1907 9.48108 24.6825C9.07117 24.9191 8.61366 25.0512 8.13932 25.0514C7.66456 25.0516 7.20719 24.9194 6.79699 24.6825L1.34228 21.5332C0.490201 21.0413 0 20.1922 0 19.2083V3.12011C0 1.63975 1.20425 0.435547 2.68457 0.435547H14.6978C16.1782 0.435547 17.3826 1.63965 17.3826 3.12011V6.51147C17.3826 6.99797 16.9876 7.39297 16.5011 7.39297C16.0144 7.39297 15.6197 6.99801 15.6197 6.51147V3.12011C15.6197 2.61179 15.2061 2.19817 14.6978 2.19817H4.17108L9.48108 5.26443C10.3328 5.75626 10.8234 6.60532 10.8234 7.58884V19.368H14.6978C15.2061 19.368 15.6197 18.9547 15.6197 18.4463V15.4734C15.6197 14.9865 16.0142 14.5918 16.5011 14.5918C16.9877 14.5918 17.3826 14.9866 17.3826 15.4734V18.4463C17.3826 19.9267 16.1782 21.1309 14.6978 21.1309H10.8234ZM18.991 11.6645L18.0202 12.6352C17.676 12.9794 17.6761 13.5374 18.0202 13.8816C18.1859 14.0474 18.4092 14.1395 18.6434 14.1395C18.878 14.1395 19.101 14.0477 19.2669 13.8816L21.7419 11.4062C22.086 11.0621 22.0861 10.5044 21.7419 10.1602L19.2669 7.68519C18.9227 7.34095 18.3646 7.3411 18.0203 7.68514C17.6762 8.02899 17.6763 8.58722 18.0203 8.93117L18.991 9.90167H12.488C12.001 9.90167 11.6066 10.2963 11.6066 10.7832C11.6066 11.2702 12.001 11.6645 12.488 11.6645H18.991V11.6645Z"
                                fill="#AA0E17"
                              />
                            </svg>
                            <SidebarLabel>Logout</SidebarLabel>
                          </div> */}
                          <Button
                            variant="contained"
                            onClick={() =>
                              openDelete(
                                "Are you sure you want to Logout?",
                                true,
                                null
                              )
                            }
                            id="btn-logout"
                          >
                            Logout &nbsp;
                            <MdIcons.MdLogout className="log-icon" />
                          </Button>
                        </div>
                      </li>
                    </ul>
                  </Col>
                </Row>
              </Container>
              <Container fluid>
                <div className="outlet">
                  <div className="content-wrapper mt-5 d-flex">
                    <Outlet />
                  </div>
                </div>
              </Container>
            </div>
          </div>
        </div>
      </>
    </React.Fragment>
  );
}
export default memo(Sidebar);
